import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { preloadAndCacheImage } from '../utils/imageCacheUtils';
import { getLocalizedText } from '../utils/textLocalization';

// Cache key for novinky images
const NOVINKY_CACHE_KEY = 'nukeproofNovinkyImages';

// A component to render a novinka item
const NovinkyItem = ({ novinka, index, nukeproofImage }) => {
  // Get localized text
  const showButtonText = getLocalizedText('general.show_button');
  
  // Helper function to safely extract string values from Builder.io content
  const safeString = (value, fallback = '') => {
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && value !== null) {
      // Handle Builder.io rich text objects
      if (value.Default) return value.Default;
      if (value['@type'] === 'string' && value.value) return value.value;
      // Try to extract text content if it's a complex object
      if (value.text) return value.text;
      if (value.content) return value.content;
    }
    return fallback;
  };

  const imageUrl = novinka.data?.image || nukeproofImage;
  const route = novinka.data?.route || '#';
  const linkTarget = novinka.linkTo || `/article/${route}`;
  
  // Use effect to preload and cache the image
  useEffect(() => {
    // Preload and cache the image
    const preloadImage = async () => {
      await preloadAndCacheImage(imageUrl, NOVINKY_CACHE_KEY, nukeproofImage);
    };
    
    preloadImage();
    
    return () => {
      // Cleanup if needed
    };
  }, [imageUrl, nukeproofImage]);
  
  return (
    <NavLink to={linkTarget}>
      <div className="novinky-box">
        <div>
          <img
            src={imageUrl}
            alt="Nukeproof novinky"
            onError={(e) => {
              console.warn("Image failed to load, using fallback");
              e.target.src = nukeproofImage;
            }}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block'
            }}
          />
          <span>{safeString(novinka.data?.tag, 'Novinky')}</span>
        </div>
        <button><span>{showButtonText}</span></button>
        <h2>{safeString(novinka.data?.title, 'Článek')}</h2>
        <p>{novinka.data?.description ? 
          safeString(novinka.data.description, 'Popis článku...').replace(/<[^>]*>/g, '').substring(0, 100) + '...' : 
          'Popis článku...'}
        </p>
      </div>
    </NavLink>
  );
};

export default NovinkyItem;
